export default __webpack_public_path__ + "static/media/heart.4841c48c.png";